import React from 'react';
import PropTypes from 'prop-types';
import styles from './MessageComponent.module.scss';

const MessageComponent = ({ message }) => {
  if (!message) return null;

  return (
    <div
      className={`${styles.message} ${
        message.includes("Error") ? styles.error : styles.success
      }`}
    >
      {message}
    </div>
  );
};

MessageComponent.propTypes = {
  message: PropTypes.string.isRequired
};

export default MessageComponent;